import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { API } from "../api";
import { ConditionClauseResourceDto } from "../dtos/Centralized/condition-clause-resource-dto";
import { ConditionDto } from "../dtos/Centralized/condition-dto";
import { CreateConditionClauseResourceDto } from "../dtos/Centralized/create-condition-clause-resource-dto";

export const UserRegistrationConditionService = {
	async getConditionClauses(conditionClauseId: any): Promise<ConditionDto> {
		const language = localStorage.getItem("language") ?? "es";
		const res = await ItiHttpService.get(
			`${API.centralizedAuth.conditionClause}/${language}/${conditionClauseId}`,
		);

		return new ConditionDto(res);
	},
	async createConditionClauseUser(
		conditionResource: ConditionClauseResourceDto[],
	): Promise<string> {
		return await ItiHttpService.post(
			`${API.centralizedAuth.conditionClause}/condition-user`,
			JSON.stringify(conditionResource),
			true,
			true,
			true,
		);
	},
	async createConditionClauseResource(
		conditionResource: CreateConditionClauseResourceDto[],
	): Promise<string> {
		return await ItiHttpService.post(
			`${API.centralizedAuth.conditionClause}/condition-resource`,
			JSON.stringify(conditionResource),
			true,
			true,
			true,
		);
	},
};
